
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4ef1"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4ef1"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
// Copyright 2023 The MediaPipe Authors.
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//      http://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var $fgYff = parcelRequire("fgYff");
let $7332f12928398b54$var$socketFace = new WebSocket("ws://localhost:3001");
let $7332f12928398b54$var$faceLandmarker;
let $7332f12928398b54$var$runningMode = "VIDEO";
let $7332f12928398b54$var$enableWebcamButton;
let $7332f12928398b54$var$webcamRunning = false;
const $7332f12928398b54$var$videoWidth = "480px";
console.log("Load OK");
// Before we can use HandLandmarker class we must wait for it to finish
// loading. Machine Learning models can be large and take a moment to
// get everything needed to run.
async function $7332f12928398b54$var$createFaceLandmarker() {
    const filesetResolver = await (0, $fgYff.FilesetResolver).forVisionTasks("https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.0/wasm");
    $7332f12928398b54$var$faceLandmarker = await (0, $fgYff.FaceLandmarker).createFromOptions(filesetResolver, {
        baseOptions: {
            modelAssetPath: `https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task`,
            delegate: "GPU"
        },
        outputFaceBlendshapes: true,
        runningMode: $7332f12928398b54$var$runningMode,
        numFaces: 1
    });
}
$7332f12928398b54$var$createFaceLandmarker();
const $7332f12928398b54$var$video2 = document.querySelector(".video2");
const $7332f12928398b54$var$canvasElement = document.querySelector(".canvas2");
const $7332f12928398b54$var$canvasCtx = $7332f12928398b54$var$canvasElement.getContext("2d");
const $7332f12928398b54$var$hasGetUserMedia = ()=>{
    var mediaDevices;
    return !!((mediaDevices = navigator.mediaDevices) === null || mediaDevices === void 0 ? void 0 : mediaDevices.getUserMedia);
};
if ($7332f12928398b54$var$hasGetUserMedia()) {
    $7332f12928398b54$var$enableWebcamButton = document.querySelector("button");
    $7332f12928398b54$var$enableWebcamButton.addEventListener("click", $7332f12928398b54$var$enableCam);
}
function $7332f12928398b54$var$enableCam(event) {
    let select = document.querySelector("#video-select2");
    select.innerHTML = `<option></option>`;
    navigator.mediaDevices.enumerateDevices().then((device)=>{
        device.forEach((item, index)=>{
            if (item.kind === "videoinput") {
                // type the device id to select
                select.addEventListener("change", $7332f12928398b54$var$changeVideo);
                select.innerHTML += `<option value="${item.deviceId}">${item.label}</option>`;
            }
        });
    });
    $7332f12928398b54$var$video2.addEventListener("loadeddata", $7332f12928398b54$var$predictFace);
}
let $7332f12928398b54$var$mediaRecorderFace = null;
let $7332f12928398b54$var$isConnect = false;
let $7332f12928398b54$var$cameraId = "";
async function $7332f12928398b54$var$changeVideo(event) {
    let deviceId = event.target.value;
    $7332f12928398b54$var$cameraId = deviceId;
    let stream = await navigator.mediaDevices.getUserMedia({
        video: {
            deviceId: deviceId
        }
    });
    $7332f12928398b54$var$video2.srcObject = stream;
    console.log("changeVideo2");
    if (deviceId === "" && $7332f12928398b54$var$isConnect) {
        $7332f12928398b54$var$mediaRecorderFace.stop();
        return;
    }
    $7332f12928398b54$var$recordVideo(deviceId);
}
async function $7332f12928398b54$var$recordVideo(deviceId) {
    let stream = await navigator.mediaDevices.getUserMedia({
        video: {
            deviceId: deviceId
        }
    });
    if ($7332f12928398b54$var$isConnect && $7332f12928398b54$var$isRecord) {
        $7332f12928398b54$var$mediaRecorderFace = new MediaRecorder(stream);
        $7332f12928398b54$var$mediaRecorderFace.ondataavailable = (event)=>{
            if (!$7332f12928398b54$var$isConnect) return;
            if (event.data && event.data.size > 0) $7332f12928398b54$var$socketFace.send(event.data);
        };
        $7332f12928398b54$var$mediaRecorderFace.start(200);
    }
}
let $7332f12928398b54$var$lastVideoTime = -1;
let $7332f12928398b54$var$results = undefined;
const $7332f12928398b54$var$drawingUtils = new (0, $fgYff.DrawingUtils)($7332f12928398b54$var$canvasCtx);
async function $7332f12928398b54$var$predictFace() {
    const radio = $7332f12928398b54$var$video2.videoHeight / $7332f12928398b54$var$video2.videoWidth;
    $7332f12928398b54$var$video2.style.width = $7332f12928398b54$var$videoWidth + "px";
    $7332f12928398b54$var$video2.style.height = $7332f12928398b54$var$videoWidth * radio + "px";
    $7332f12928398b54$var$canvasElement.style.width = $7332f12928398b54$var$videoWidth + "px";
    $7332f12928398b54$var$canvasElement.style.height = $7332f12928398b54$var$videoWidth * radio + "px";
    $7332f12928398b54$var$canvasElement.width = $7332f12928398b54$var$video2.videoWidth;
    $7332f12928398b54$var$canvasElement.height = $7332f12928398b54$var$video2.videoHeight;
    // Now let's start detecting the stream.
    if ($7332f12928398b54$var$runningMode === "IMAGE") {
        $7332f12928398b54$var$runningMode = "VIDEO";
        await $7332f12928398b54$var$faceLandmarker.setOptions({
            runningMode: $7332f12928398b54$var$runningMode
        });
    }
    let startTimeMs = performance.now();
    if ($7332f12928398b54$var$lastVideoTime !== $7332f12928398b54$var$video2.currentTime) {
        $7332f12928398b54$var$lastVideoTime = $7332f12928398b54$var$video2.currentTime;
        $7332f12928398b54$var$results = $7332f12928398b54$var$faceLandmarker.detectForVideo($7332f12928398b54$var$video2, startTimeMs);
    }
    if ($7332f12928398b54$var$results.faceLandmarks) for (const landmarks of $7332f12928398b54$var$results.faceLandmarks){
        $7332f12928398b54$var$drawingUtils.drawConnectors(landmarks, (0, $fgYff.FaceLandmarker).FACE_LANDMARKS_TESSELATION, {
            color: "#C0C0C070",
            lineWidth: 1
        });
        $7332f12928398b54$var$drawingUtils.drawConnectors(landmarks, (0, $fgYff.FaceLandmarker).FACE_LANDMARKS_RIGHT_EYE, {
            color: "#FF3030"
        });
        $7332f12928398b54$var$drawingUtils.drawConnectors(landmarks, (0, $fgYff.FaceLandmarker).FACE_LANDMARKS_RIGHT_EYEBROW, {
            color: "#FF3030"
        });
        $7332f12928398b54$var$drawingUtils.drawConnectors(landmarks, (0, $fgYff.FaceLandmarker).FACE_LANDMARKS_LEFT_EYE, {
            color: "#30FF30"
        });
        $7332f12928398b54$var$drawingUtils.drawConnectors(landmarks, (0, $fgYff.FaceLandmarker).FACE_LANDMARKS_LEFT_EYEBROW, {
            color: "#30FF30"
        });
        $7332f12928398b54$var$drawingUtils.drawConnectors(landmarks, (0, $fgYff.FaceLandmarker).FACE_LANDMARKS_FACE_OVAL, {
            color: "#E0E0E0"
        });
        $7332f12928398b54$var$drawingUtils.drawConnectors(landmarks, (0, $fgYff.FaceLandmarker).FACE_LANDMARKS_LIPS, {
            color: "#E0E0E0"
        });
        $7332f12928398b54$var$drawingUtils.drawConnectors(landmarks, (0, $fgYff.FaceLandmarker).FACE_LANDMARKS_RIGHT_IRIS, {
            color: "#FF3030"
        });
        $7332f12928398b54$var$drawingUtils.drawConnectors(landmarks, (0, $fgYff.FaceLandmarker).FACE_LANDMARKS_LEFT_IRIS, {
            color: "#30FF30"
        });
    }
    // Call this function again to keep predicting when the browser is ready.
    window.requestAnimationFrame($7332f12928398b54$var$predictFace);
}
$7332f12928398b54$var$socketFace.addEventListener("error", $7332f12928398b54$var$socketError);
$7332f12928398b54$var$socketFace.addEventListener("open", $7332f12928398b54$var$socketOpen);
$7332f12928398b54$var$socketFace.addEventListener("close", $7332f12928398b54$var$socketClose);
$7332f12928398b54$var$socketFace.addEventListener("message", $7332f12928398b54$var$socketMessage);
function $7332f12928398b54$var$socketError(error) {
    $7332f12928398b54$var$isConnect = false;
    console.log("\u6C92\u6709\u9023\u7DDA");
    console.log(error);
}
function $7332f12928398b54$var$socketOpen(event) {
    $7332f12928398b54$var$isConnect = true;
    console.log("\u9023\u7DDA\u6210\u529F");
    return;
}
function $7332f12928398b54$var$socketClose(event) {
    $7332f12928398b54$var$isConnect = false;
    console.log("\u9023\u7DDA\u4E2D\u65B7");
}
function $7332f12928398b54$var$socketMessage(event) {
    console.log("\u6536\u5230\u8A0A\u606F");
}
let $7332f12928398b54$var$isRecord = false;
let $7332f12928398b54$var$recordBtn = document.querySelector("#recordF");
$7332f12928398b54$var$recordBtn.addEventListener("click", ()=>{
    console.log($7332f12928398b54$var$isRecord);
    if (!$7332f12928398b54$var$isRecord) {
        $7332f12928398b54$var$recordVideo($7332f12928398b54$var$cameraId);
        $7332f12928398b54$var$isRecord = !$7332f12928398b54$var$isRecord;
        $7332f12928398b54$var$recordBtn.textContent = "Stop Record Pose";
        return;
    } else {
        $7332f12928398b54$var$isRecord = !$7332f12928398b54$var$isRecord;
        $7332f12928398b54$var$recordBtn.textContent = "Start Record Pose";
        $7332f12928398b54$var$mediaRecorderFace.stop();
    }
});


//# sourceMappingURL=index.891b793b.js.map
